import request from "@/api/config.js";

export function getLangsList() {
  return request({
    url: `courses-lang/`,
    method: "get",
  });
}
